import React, { useState } from "react";
// Sections
import TopNavbar from "../components/Nav/TopNavbar";
import Header from "../components/Sections/Header";
import Services from "../components/Sections/Services";
import Projects from "../components/Sections/Projects";
import Contact from "../components/Sections/Contact";
import Footer from "../components/Sections/Footer";
import { LanguageContext } from "./LanguageContext";

export default function Landing() {
  const [language, setLanguage] = useState("en");
  const toggleLanguage = () => setLanguage((prevLang) => (prevLang === "en" ? "ar" : "en"));

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      <TopNavbar />
      <Header />
      <Services />
      <Projects />
      <Contact />
      <Footer />
    </LanguageContext.Provider>
  );
}
